module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAOVBMVEX///8zMzM6OjrJycl8fHxdXV309PTLy8vFxcX6+vrt7e3m5ubT09PAwMCpqamcnJyDg4Nvb29SUlJJvsnlAAAAlElEQVQ4y+3TywrDMAxEUY2cNsqrSfr/H1uaUgZsldmWkLs0By0sZFd/3RCjNcWU2ye8VG/3GxAZDgDeNxZdhkd/61JbPCyrd86mPQZLTas1rda0WtNqvdBqDVqlaXXLYXfp+GfcpbbU2u6uNXdRqKU1am0rLSy1tlp/baXnXzdIS71lePrYRq+WFV17m/O2DnZ1ml6m5wOuE2uWkQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/icon_close.png
// module id = Ta+A
// module chunks = 0